module.exports = __webpack_public_path__ + "components/collaborations-header/static/header--large@2x-93a1f8b0a6b089f6a539b16f2cf6124d.jpg";